// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    COMPANY_DATA_LOADING() {
      return {
        isLoading: true
      };
    },
    COMPANY_DATA_LOADED() {
      return {
        isLoading: false,
        data: action.companyData
      };
    },
    COMPANY_DATA_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.companyData.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
